module.exports = __webpack_public_path__ + "static/media/live-carousel-mobile-bl.1fc7557a.png";